import { render, staticRenderFns } from "./WareHouseStock.vue?vue&type=template&id=646a5fa4&scoped=true"
import script from "./WareHouseStock.vue?vue&type=script&lang=js"
export * from "./WareHouseStock.vue?vue&type=script&lang=js"
import style0 from "./WareHouseStock.vue?vue&type=style&index=0&id=646a5fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a5fa4",
  null
  
)

export default component.exports